import React, { Suspense } from 'react';
import { pick } from 'ramda';
import { languageService } from '@theme/js/services/language.service';
import { SessionTicker } from '@theme/js/components/main/SessionTicker';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';
import { Link } from '@theme/js/components/common/Link';
import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';

import { Logo } from '../Logo';
import { UserInfoSection } from '../UserInfoSection';
import { AdditionalUserInfo } from '@core/js/components/main/DefaultHeader/components/AdditionalUserInfo';
import * as hooks from '@core/js/components/main/DefaultHeader/hooks';

import style from './DesktopHeader.scss';

export const DesktopHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const onLoginButtonClick = hooks.useOnLoginButtonClick();

    /* Lugano changes */
    const { lang, isLoggedIn } = useUserSelector(pick(['lang', 'isLoggedIn']));
    const language = languageService.getTwoLetterLanguage(lang);
    const { showSessionTicker, registrationURL, dynamicTags } = useAppSelector(pick([
        'showSessionTicker', 'registrationURL', 'dynamicTags'
    ]));
    const regDTagName = `DTAG_LINK_REGISTRATION_${language.toUpperCase()}`;
    const regLink = dynamicTags[regDTagName] || registrationURL || '/';
    /* Lugano changes */

    return (
        <div className={style.header}>
            <div className={`${style.info} ${showSessionTicker ? 'show-session-ticker' : ''}`}>
                <Logo />
                {isLoggedIn && showSessionTicker && (
                    <Suspense fallback="">
                        <SessionTicker className={style.ticker} />
                    </Suspense>
                )}
            </div>
            <div className={style.controls}>
                {isLoggedIn
                    ? (
                        <>
                            <AdditionalUserInfo />
                            <UserInfoSection /> {/* Lugano changes */}
                        </>
                    )
                    : (
                        /* Lugano changes */
                        <>
                            <button className={style.login} onClick={onLoginButtonClick}>
                                {translate('login.button.loginHeader')}
                            </button>
                            <Link href={regLink} className={style.register}>
                                {translate('login.button.join_now')}
                            </Link>
                        </>
                        /* Lugano changes */
                    )
                }
            </div>
        </div>
    );
};
